/** Text → Generate Audio "输入文本" edge helpers (VistoeraTASK-00074).
 *
 * Single active text source, mirroring `canvasVoiceTemplateBinding.ts`'s
 * exact shape one-for-one (same strip-before-add single-cardinality
 * policy, same `nodeTypeById` lookup contract) — never a second,
 * drifting copy of that pattern's semantics for what is structurally
 * the same "one Generate Audio input, at most one live edge" rule. */

import type { Edge } from '@xyflow/react'
import { AUDIO_TEXT_INPUT_HANDLE, GENERIC_INPUT_HANDLE } from './dataflow'

export const AUDIO_TEXT_OUTPUT_HANDLE = 'text-out'

export function isTextInputSourceNode(nodeType: string | undefined): boolean {
  return nodeType === 'text_asset' || nodeType === 'generate_text'
}

export function isTextInputToGenerateAudioEdge(edge: Edge, nodeTypeById: Map<string, string>): boolean {
  if (
    edge.targetHandle !== GENERIC_INPUT_HANDLE &&
    edge.targetHandle !== AUDIO_TEXT_INPUT_HANDLE &&
    edge.targetHandle != null
  ) {
    return false
  }
  if (edge.sourceHandle && edge.sourceHandle !== AUDIO_TEXT_OUTPUT_HANDLE) return false
  return isTextInputSourceNode(nodeTypeById.get(edge.source))
}

export function textInputEdgesToTarget(edges: Edge[], targetId: string, nodeTypeById: Map<string, string>): Edge[] {
  return edges.filter((e) => e.target === targetId && isTextInputToGenerateAudioEdge(e, nodeTypeById))
}

export function stripTextInputEdgesToTarget(
  edges: Edge[],
  targetId: string,
  nodeTypeById: Map<string, string>,
): Edge[] {
  return edges.filter((e) => !isTextInputToGenerateAudioEdge(e, nodeTypeById) || e.target !== targetId)
}
